/* Product lists: GA4 view_item_list once per list, select_item per tap, the
   Live params (CLAUDE.md contract). list_id = collection handle, or the list's
   own data-list-id for the homepage rows.

   Every [data-collection] on the page is instrumented, not just the first, so
   the homepage's featured squares and its collection carousel each report as
   their own list (AS, 2026-09-18).

   The gtag guard is per call. It used to return from this whole function when
   gtag was absent, which killed view_item_list AND every later select_item for
   the life of the page; every other asset in this theme guards per call. */
(function () {
  'use strict';
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-collection]'));
  if (!roots.length) return;

  function send(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }

  function item(c) {
    return {
      item_id: c.getAttribute('data-product-id') || '',
      item_name: c.getAttribute('data-title') || '',
      item_handle: c.getAttribute('data-handle') || '',
      item_brand: 'Alatreyu',
      index: parseInt(c.getAttribute('data-position'), 10) || 0
    };
  }

  roots.forEach(function (root) {
    /* The homepage includes this asset once per list section, so the file runs
       more than once on that page. Without this flag each run would send a
       second view_item_list and bind a second click handler, doubling the
       numbers (AS, 2026-09-18). */
    if (root.getAttribute('data-ga-bound')) return;
    root.setAttribute('data-ga-bound', '1');
    var listId = root.getAttribute('data-list-id') || '';
    var listName = root.getAttribute('data-list-name') || '';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-position]'));
    if (!cards.length) return;
    send('view_item_list', { item_list_id: listId, item_list_name: listName, items: cards.slice(0, 25).map(item) });
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-position]');
      if (!c) return;
      send('select_item', { item_list_id: listId, item_list_name: listName, items: [item(c)] });
    });
  });
})();
